import careerRouter from '../../components/page-career/index'

export default [
    {
        path: '/career',
        name: 'career',
        component: () => import('../../views/career'),
        children: [
            ...careerRouter
        ]
    }
]